const mainBatterySignal = {
  null: 'Null',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
}

export default mainBatterySignal
